export default __webpack_public_path__ + "static/media/arrow-right.7e700490.svg";